<template>
    <div class="cc-login">
        <div class="cc-login__header">
            <div class="cc-login__title">{{ translations['Already registered?'] }}</div>
            <a class="cc-link cc-login__toggle" @click="toggleLogin">{{ translations['Sign in!'] }}</a>
        </div>
        <div class="cc-login__main" v-if="isUserLoginFormShown">
            <div class="cc-form-input">
                <label for="login.email" class="cc-label cc-label--text">{{ translations['Email'] }}*</label>
                <input id="login.email" type="email" name="login.email" class="cc-input cc-input--text">
                <div class="cc-alert cc-alert--error" v-if="user.loginErrors.email">{{ user.loginErrors.email }}</div>
            </div>
            <div class="cc-form-input">
                <label for="login.password" class="cc-label cc-label--text">{{ translations['Password'] }}*</label>
                <input id="login.password" type="password" name="login.password" class="cc-input cc-input--text">
                <div class="cc-alert cc-alert--error" v-if="user.loginErrors.password">{{ user.loginErrors.password }}</div>
            </div>
            <div class="cc-login__forgot-password">
                <a :href="config.forgotten_password.link" class="cc-link">{{ config.forgotten_password.name }}</a>
            </div>
            <div class="cc-login__buttons">
                <a class="cc-button cc-button--grey" @click="login">{{ translations['Sign in'] }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                config: state => state.config,
                selectedCountry: state => state.user.deliveryAddress.country,
            }),
        },
        data() {
            return {
                isUserLoginFormShown: false,
            };
        },
        methods: {
            toggleLogin: function () {
                this.isUserLoginFormShown = !this.isUserLoginFormShown;
            },
            login: function () {
                this.showLoading();
                const emailInput = document.getElementById('login.email');
                const passwordInput = document.getElementById('login.password');

                let that = this;

                this.$store.dispatch('USER_LOGIN', {email: emailInput.value, password: passwordInput.value})
                    .then(function () {
                        if (typeof $.uniform !== 'undefined') {
                          $.uniform.update();
                        }
                        that.hideLoading();
                    });
            },
            showLoading: function () {
                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);
            },
            hideLoading: function () {
                document.getElementById('cart-cover-spin').remove();
            },
        },
        name: 'Login',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-login {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-login__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-login__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-login__toggle {
            font-weight: bold;
            margin-left: 1.5rem;
        }

        .cc-login__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }

        .cc-input {
            &.cc-input--text {
                width: 100%;
            }
        }

        .cc-login__forgot-password {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 3rem;
        }

        .cc-login__buttons {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 1rem;
        }
    }
</style>
